import { render } from "./ProfileGroups.vue?vue&type=template&id=27186653"
import script from "./ProfileGroups.vue?vue&type=script&lang=js"
export * from "./ProfileGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__